import React from 'react';
import PropTypes from 'prop-types';
import request from '../../../request';
import Input from '../../shared/labelInput';

export default class Add extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    this.state = {};
  }

  async create() {
    try {
      this.setState({ loading: true });
      let { id } = await request({
        url: `admin/companies`,
        method: 'POST',
        body: this.state,
      });
      this.context.router.history.push(`/settings/companies/${id}/users`);
    } catch (e) {
      this.setState({ message: e.message || e });
    }
  }

  render() {
    let {
      fax,
      zip,
      city,
      name,
      state,
      email,
      phone,
      message,
      address,
      address_2,
      phone_extension,
    } = this.state;
    let states = [
      'AL',
      'AK',
      'AZ',
      'AR',
      'CA',
      'CO',
      'CT',
      'DE',
      'FL',
      'GA',
      'HI',
      'ID',
      'IL',
      'IN',
      'IA',
      'KS',
      'KY',
      'LA',
      'ME',
      'MD',
      'MA',
      'MI',
      'MN',
      'MS',
      'MO',
      'MT',
      'NE',
      'NV',
      'NH',
      'NJ',
      'NM',
      'NY',
      'NC',
      'ND',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VT',
      'VA',
      'WA',
      'WV',
      'WI',
      'WY',
    ];
    return (
      <div id="dashboard">
        <h5 className="heading">Add</h5>
        {message ? <p className="error">{message}</p> : null}
        <Input
          name="name"
          label="Name"
          value={name || ''}
          onChange={e => this.setState({ name: e.target.value })}
        />

        <Input
          name="emailr"
          label="Email"
          value={email || ''}
          onChange={e => this.setState({ email: e.target.value })}
        />
        <Input
          name="phone_extension"
          label="Phone Ext"
          value={phone_extension || ''}
          onChange={e => this.setState({ phone_extension: e.target.value })}
        />
        <Input
          name="phone"
          label="Phone"
          value={phone || ''}
          onChange={e => this.setState({ phone: e.target.value })}
        />

        <Input
          name="fax"
          label="Fax"
          value={fax || ''}
          onChange={e => this.setState({ fax: e.target.value })}
        />

        <Input
          name="address"
          label="Address"
          value={address || ''}
          onChange={e => this.setState({ address: e.target.value })}
        />

        <Input
          name="address_2"
          label="Address Line 2"
          value={address_2 || ''}
          onChange={e => this.setState({ address_2: e.target.value })}
        />

        <Input
          name="city"
          label="City"
          value={city || ''}
          onChange={e => this.setState({ city: e.target.value })}
        />
        <div className="field">
          <label for="state">State</label>
          <select
            name="state"
            value={state || ''}
            onChange={e => this.setState({ state: e.target.value })}
          >
            <option value="">Select State</option>
            {states.map(state => (
              <option key={state} value={state}>{state}</option>
            ))}
          </select>
        </div>
        <Input
          name="zip"
          label="Zip"
          value={zip || ''}
          onChange={e => this.setState({ zip: e.target.value })}
        />

        <div className="options">
          <button
            className="control_button"
            id="save"
            type="submit"
            onClick={() => this.create()}
          >
            Save
          </button>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/companies/add.js